import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';


class GetAvailableCoupons extends baseRequest{

    constructor(listener) {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Get Available Coupons';
        this.Config   = new AppConfig();
        this.route    = null;
        this.listener = listener;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getAvailableCoupons, { ...payload, newResponseFormat: 1 });
    }

    //Parse successful response
    onSuccess() {
        if (this.response.data.isSuccess === false){
            const resError = {
                code: 413,
                message: this.response.data.result,
                content: this.response.data.result,
                isSubsided: true,
                status: this.response.data.code,
            }
            typeof this.listener?.onFailure === 'function' && this.listener.onFailure(resError)
            // typeof this.listener?.onFailure === 'function' && this.listener.onFailure(resError);
        }else {
            typeof this.listener?.onSuccess === 'function' && this.listener.onSuccess(this.response.data);
        }
    }

    onFailure() {
        typeof this.listener?.onFailure === 'function' && this.listener.onFailure(this.response.err);
    }
}


export default GetAvailableCoupons;
